<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Add Execution Broker</ng-container>

    <ng-container *ngIf="form && form.formGroup" dialog-process-in-progress>
        <form [formGroup]="form.formGroup" class="row add-exchange-form">
            <div [ngClass]="{'mb-3': form.controls.name.errors?.length > 0}" class="col-12">
                <app-panel-input [control]="form.controls.name" [formControlName]="form.controls.name.name"></app-panel-input>
            </div>
            <div [ngClass]="{'mb-3': form.controls.code.errors?.length > 0}" class="col-12">
                <app-panel-input [control]="form.controls.code" [formControlName]="form.controls.code.name"></app-panel-input>
            </div>
        </form>
    </ng-container>
</app-dialog>
